<template>
  <section class="countdown-section">
    <h2> {{title}} </h2>
    <div class="countdown-container">
      <div class="countdown-cell">
        <span class="countdown-digit"> {{countdown.days | numFormat("00")}} </span>
        <span class="countdown-subtitle"> days </span>

      </div>
      <span class="countdown-digit"> : </span>

      <div class="countdown-cell">
        <span class="countdown-digit"> {{countdown.hours | numFormat("00")}} </span>
        <span class="countdown-subtitle"> hours </span>
      </div>
      <span class="countdown-digit"> : </span>

      <div class="countdown-cell">
        <span class="countdown-digit"> {{countdown.minutes | numFormat("00")}} </span>
        <span class="countdown-subtitle"> minutes </span>
      </div>
      <span class="countdown-digit"> : </span>

      <div class="countdown-cell">
        <span class="countdown-digit"> {{countdown.seconds | numFormat("00")}} </span>
        <span class="countdown-subtitle"> seconds </span>
      </div>
    </div>
  </section>

</template>

<script>
  export default {
    name: 'CountDown',
    props: {
      startdate: Number
    },
    data() {
      return {
        title:"",
        countdown: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,

        },
        countdown_string: "",
      }
    },
    methods: { 
      handler() {
       // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = this.countDownDate - now;
        if (distance > 0) {
          this.title = "Starting in"
        } else {
          distance = this.countUpDate - now;
          this.title = "Time remaining"
        }
        // Time calculations for days, hours, minutes and seconds
        this.countdown.days = Math.max(0, Math.floor(distance / (1000 * 60 * 60 * 24)));
        this.countdown.hours = Math.max(0, Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        this.countdown.minutes = Math.max(0, Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
        this.countdown.seconds = Math.max(0, Math.floor((distance % (1000 * 60)) / 1000));
        
      }
    },

    created() {
      /* eslint-disable */
      // Set the date we're counting down to
      this.countDownDate = new Date(this.startdate * 1000).getTime();
      this.countUpDate = new Date((this.startdate + 7*24*60*60) * 1000).getTime();

      // Update the count down every 1 second
      this.countdown_timer = setInterval(this.handler, 1000);
      this.handler();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .countdown-section {
    margin: 0px 0px;
  }
  .countdown-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .countdown-cell {
    margin: 5px;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 10px;

    display: flex;
    flex-direction: column;
  }

  .countdown-digit {
    font-size: 24px;
    font-family: 'ProximaNova-Bold', 'Avenir', Helvetica, Arial, sans-serif;

  }

  .countdown-subtitle {
    font-size: 14px;

  }


  @media only screen and (min-width: 600px) {
    .countdown-cell {
      margin: 10px;

    }
    .countdown-digit {
      font-size: 60px;
    }
    .countdown-subtitle {
      font-size: 16px;

    }
  }
    @media only screen and (min-width: 1024px) {
    .countdown-cell {
      margin: 20px;

    }
    .countdown-digit {
      font-size: 60px;
    }
    .countdown-subtitle {
      font-size: 20px;

    }
  }
</style>